module.exports = __webpack_public_path__ + "static/media/cm.ba51e650.svg";